import type { AppRouteModule } from '/@/router/types';
import { RoleEnum } from '/@/enums/roleEnum';
import { LAYOUT } from '/@/router/constant';
import { t } from '/@/hooks/web/useI18n';

const data: AppRouteModule = {
  path: '/data',
  name: 'Data',
  component: LAYOUT,
  redirect: '/data/user',
  meta: {
    orderNo: 4,
    icon: 'gala:data',
    title: t('routes.nurse.dataMgt'),
    hideChildrenInMenu: false,
    roles: [RoleEnum.SUPERADMIN, RoleEnum.ADMIN, RoleEnum.OPERATOR],
  },
  children: [
    {
      path: 'user',
      name: 'DataUser',
      component: () => import('/@/views/nurse/data-management/person/index.vue'),
      meta: {
        icon: 'tabler:user-cog',
        title: t('routes.nurse.userMgt'),
      },
    },
    {
      path: 'device',
      name: 'DataDevice',
      component: () => import('/@/views/nurse/data-management/device/index.vue'),
      meta: {
        icon: 'tabler:device-ipad-cog',
        title: t('routes.nurse.deviceMgt'),
      },
    },
    {
      path: 'order',
      name: 'DataOrder',
      component: () => import('/@/views/nurse/data-management/order/index.vue'),
      meta: {
        icon: 'lsicon:work-order-check-outline',
        title: t('routes.nurse.orderMgt'),
      },
    },
  ],
};

export default data;
